import RoleAdvancedView from './RoleAdvancedView'

export default RoleAdvancedView
